export class File {
  type: string;
  icon: string;
  name: string;
  full_path_old: string;
  full_path: string;
  owner: string;
  users: Array<string>;
  cdateFormatted: string;
  size: number;
  cdate: number;
  mdate: number;
  ext: string;
  isSnapshot = false;
  isSelected = false;
  isInFocus = false;
  isPending = false;
  isError = false;
  animateAndFocus = false;
  jobID: string; // background job UUID
  jobNextAction: string; // e.g. 'delete' if delete job successes
  get isDirectory(): boolean {
    return this.type === 'd'
  }
  get isStorage(): boolean {
    return this.type === 'b'
  }
  get isShared(): boolean {
    return this.type === 's'
  }
  get isFile(): boolean {
    return this.type === 'f'
  }
  get isNotAccessible(): boolean {
    return this.isPending || this.isError
  }
  static genFile({ name, type, owner, perm, time, size, path }): File {
    const file = new File()
    file.name = name;
    file.type = type;
    file.size = size;
    file.full_path = (`${path}/${file.name}`).replace(/\/+/g, '/');
    file.cdate = time;
    if (file.isFile) {
      const splitedName = file.name.split('.');
      file.ext = splitedName[splitedName.length - 1];
    }
    return file
  }
}
